export const AlertStatusEnum = [
    { title: 'All', value: '' },
    { title: 'New', value: 1 },
    { title: 'Read', value: 2 },
]